import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { 
  ReactivateAdminMutationMutation, 
  ReactivateAdminMutationMutationVariables 
} from "../../../../../schemaTypes";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";

export const reactivateAdminMutation = gql`
  mutation ReactivateAdminMutation($email: String!) {
    reactivateAdmin(email: $email) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitReactivateAdmin: (
        values: ReactivateAdminMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      errors: NormalizedErrorMap | null;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const ReactivateAdminController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, data }] = useMutation<
    ReactivateAdminMutationMutation,
    ReactivateAdminMutationMutationVariables
  >(reactivateAdminMutation);

  const errors = data?.reactivateAdmin?.errors
    ? normalizeErrors(data.reactivateAdmin.errors)
    : null;

  const submitReactivateAdmin = async (
    values: ReactivateAdminMutationMutationVariables
  ) => {
    const response = await mutate({ variables: values });
    const reactivateAdmin = response?.data?.reactivateAdmin;
    if (reactivateAdmin?.errors) {
      return normalizeErrors(reactivateAdmin.errors);
    }
    
    return null;
  };

  const message = data?.reactivateAdmin?.message || null;

  return children({
    submitReactivateAdmin,
    loading,
    errors,
    message,
  });
};
